import {CalendarMode} from './CalendarMode';

export const listModes: CalendarMode[] = [
    "full-page-portrait-with-image",
    "compact-portrait-3x4",
    "compact-landscape-3x2x2",
    "split-a4-landscape-with-image"
];
